import React from "react"
import StockSpecificationsUpdate from "./StockSpecificationsUpdate"
import DataCard from "components/Common/DataCard"
import { prepareDataWithLoading } from "helpers/loading_helper"

export default function Specifications({ stock, loading = false }) {
  const fields = [
    { label: "Brand", value: stock?.brand?.name },
    { label: "Model", value: stock?.model?.name },
    { label: "Year", value: stock?.year?.name },
    { label: "Package", value: stock?.package?.name },
    { label: "Color", value: stock?.exterior_color?.name },
    { label: "Interior Color", value: stock?.interior_color?.name },
    {
      label: "Mileage",
      value: stock?.mileage ? `${stock.mileage.toLocaleString()} km` : "-",
    },
    { label: "Doors", value: stock?.doors },
    { label: "Seats", value: stock?.seats },
    { label: "Tire Size", value: stock?.tire_size },
    { label: "Location", value: stock?.location?.name },
  ]

  const data = prepareDataWithLoading(fields, loading)

  return (
    <DataCard
      title="Specifications"
      icon="bx bx-cog"
      data={data}
      action={loading ? null : <StockSpecificationsUpdate stock={stock} />}
    />
  )
}
